<template>
  <thead depressed outlined style="border: thin solid #E8E4E4;">
    <tr>
      <th :colspan="initColspan" class="text-center"></th>
      <th
        depressed
        outlined
        :colspan="totalColspan"
        :class="['text-center', `${classColor}--text`]"
        :style="{ 'background-color': styleColor, color: styleColor }"
      >
        {{ !showDiscarded ? "Activos" : "Descartados" }}
        <v-chip
          :color="classColor"
          class="v-chipActive"
          :style="{ color: styleColor }"
        >
          {{ total }}
        </v-chip>
        <span class="percentStyle"> ({{ totalPercent }})%</span>
      </th>
    </tr>
    <tr>
      <th :colspan="initColspan"></th>
      <!-- for by array with values tof, mof, bof -->
      <th
        v-for="{ key, colspan, name, total, percent } in subheading"
        :key="key"
        :colspan="colspan"
        :class="[
          'text-center',
          !showDiscarded ? 'blue--text text--accent-4' : 'black--text'
        ]"
        :style="{ border: `thin solid ${styleColor}` }"
      >
        {{ name }}
        <v-chip
          class="v-chipActive text-white"
          :style="{
            'background-color': !showDiscarded ? '#0091EA' : 'black',
            color: 'white'
          }"
        >
          {{ total }}
        </v-chip>
        <span class="percentStyle"> ({{ percent }})%</span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "Subheading",
  props: {
    subheading: Array,
    initColspan: Number,
    totalColspan: Number,
    showDiscarded: Boolean,
    total: Number,
    totalPercent: String
  },
  computed: {
    styleColor() {
      return !this.showDiscarded ? "#0091EA" : "#E0E0E0";
    },
    classColor() {
      return !this.showDiscarded ? "white" : "black";
    }
  }
};
</script>
